import fetcher from 'api/fetcher';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import { setLoadPayments, setPayments } from 'store/models/invoiceDetail';

const fetchPayments = (invoiceId, from, to) => {
    return (dispatch) => {
        dispatch(setLoadPayments(true));
        const queryStr = urlParser.stringify({
            dateFrom: formatDate(from),
            dateTo: formatDate(to),
        });
        fetcher.get(`/api/v1/payments/byInvoice/${invoiceId}?${queryStr}`).then((payments) => {
            dispatch([setLoadPayments(false), setPayments(payments)]);
        });
    };
};

export default fetchPayments;
